import { slugify } from '../../helpers/strings';
import { reducer, initialStateBase } from './newCollection';
import { queryStringToParams } from '../../helpers/url';
import last from 'lodash/last';
export const urls = {
    getLocations: '/api/locations',
    getLocation: id => `/api/locations/${id}`,
    getPopulars: '/api/locations/popular',
    getLocationPath: '/api/locations/path',
    getLocationPathById: id => `/api/locations/${id}/path`,
    getAutocomplete: '/api/locations/autocomplete'
};

export const initialState = {
    ...initialStateBase,
    locations: {},
    startingLocation: 0,
    countryId: '',
    selectedLocation: {},
    gps: {
        currentLocation: false,
        isFetching: false,
        status: null,
        location: {}
    },
    siLocation: {},
    topPopularLocations: {}
};

function getElements(acc, [element, ...rest]) {
    if (rest.length === 0) {
        return acc;
    }

    const childrenIds = [];
    const children = Array.isArray(element.children)
        ? element.children.map(elm => {
            childrenIds.push(elm.id);
            return {
                ...elm,
                parentId: element.id
            };
        }) : [];

    const newAcc = {
        ...acc,
        [element.id]: {
            ...element,
            slug: slugify(`${ element.name } l ${ element.id }`),
            children: childrenIds
        }
    };

    return getElements(newAcc, [...rest, ...children]);
}

const transformGetData = (state, action) => {
    const url = action.url;
    const urlWithoutParams = url.split('?')[0];
    const params = queryStringToParams(url.split('?')[1]);
    const urlId = last(urlWithoutParams.split('/'));
    const response = action.data;

    if (urlWithoutParams === urls.getLocation(urlId) && params.defaultCity) {
        if (state.selectedLocation?.id) {
            return reducer(state, action, 'LOCATIONS');
        }
        return reducer({
            ...state,
            countryId: params.countryId,
            startingLocation: response.data.id,
            elements: {
                [response.data.id]: response.data
            }
        }, action, 'LOCATIONS');
    }
    if (urlWithoutParams === urls.getLocations) {
        if (params.lat && params.lon) {
            return reducer(state, action, 'LOCATIONS');
        }

        if (params.parent && state.elements[params.parent]) {
            return reducer({
                ...state,
                elements: {
                    ...state.elements,
                    [params.parent]: {
                        ...state.elements[params.parent],
                        children: response.data.map(location => location.id)
                    }
                }
            }, action, 'LOCATIONS');
        }

        if (!response.data.length) {
            return reducer(state, action, 'LOCATIONS');
        }

        const countryId = response.data.reduce((countryId, site) => {
            if (site.type === 'COUNTRY') {
                return site.id;
            }
            return countryId;
        }, state.countryId);

        return reducer({
            ...state,
            countryId,
            startingLocation: response.data[0].id,
            elements: getElements(state.elements, response.data)
        }, action, 'LOCATIONS');
    }

    return reducer(state, action, 'LOCATIONS');
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_LOCATIONS':
            return transformGetData(state, action);
        case 'RECEIVE_AUTOCOMPLETE_LOCATIONS':
            return reducer(state, action, 'AUTOCOMPLETE_LOCATIONS');
        case 'SELECT_LOCATION':
            return {
                ...state,
                selectedLocation: action.data,
                gps: {
                    ...state.gps,
                    currentLocation: false
                }
            };
        case 'SET_LOCATION_GPS':
            return {
                ...state,
                selectedLocation: action.data
            };
        case 'SELECT_LOCATION_GPS':
            return {
                ...state,
                ...action.data
            };
        case 'ERROR_GPS_LOCATION':
            return {
                ...state,
                gps: {
                    ...state.gps,
                    ...action.data,
                    currentLocation: false,
                    isFetching: false,
                    status: 'rejected'
                }
            };
        case 'RECEIVE_GPS_LOCATION':
            return {
                ...state,
                gps: {
                    ...state.gps,
                    ...action.data,
                    currentLocation: true,
                    isFetching: false,
                    status: 'granted'
                }
            };
        case 'REQUEST_GPS_LOCATION':
            return {
                ...state,
                gps: {
                    ...state.gps,
                    currentLocation: false,
                    isFetching: true
                }
            };
        case 'UPDATE_GPS_DATA':
            return {
                ...state,
                gps: {
                    ...state.gps,
                    ...action.data
                }
            };
        case 'SET_SI_LOCATION':
            return {
                ...state,
                siLocation: action.payload
            };
        case 'REMOVE_SI_LOCATION':
            return {
                ...state,
                siLocation: {}
            };
        case 'RECEIVE_TOP_LOCATIONS':
            return {
                ...state,
                topPopularLocations: action.data
            };
        default:
            return reducer(state, action, 'LOCATIONS');
    }
};
